import {
  Button,
  HeadingRegular,
  Modal,
  NavigationItem,
} from '@pensionbee/honeypot-ui';
import { useState } from 'react';
import { useThemedImageSource } from '@/domains/theme/useThemedImageSource';
import { StageProps } from '../../config/StrongerNudgeConfig';

export const ReceivedGuidanceOption = ({
  onSubmit,
}: {
  onSubmit: StageProps['onSubmit'];
}) => {
  const manageIcon = useThemedImageSource('manage');
  const [isOpenReceivedGuidance, setIsOpenReceivedGuidance] = useState(false);

  const closeReceivedGuidance = () => setIsOpenReceivedGuidance(false);

  const openReceivedGuidance = () => setIsOpenReceivedGuidance(true);

  const handleConfirmGuidanceReceived = async () => {
    await onSubmit({ guidanceConfirmationOption: 'Guidance Confirmed' });
    closeReceivedGuidance();
  };

  return (
    <>
      <NavigationItem
        handleClick={openReceivedGuidance}
        title="I have received guidance"
        copy="I've taken guidance or regulated advice."
        src={manageIcon}
        imageHeight="48px"
      />
      <Modal
        isOpen={isOpenReceivedGuidance}
        handleClose={closeReceivedGuidance}
        variant="bottom"
      >
        <div className="flex h-full flex-col justify-between">
          <HeadingRegular className="mb-28">
            Please confirm whether you attended the appointment, received
            guidance or regulated advice, or that your personal circumstances
            have not changed since attending the appointment?
          </HeadingRegular>
          <Button
            className="mb-20 mt-auto w-full md:w-auto"
            onClick={handleConfirmGuidanceReceived}
          >
            Confirm
          </Button>
          <Button
            variant="secondary"
            className="mt-auto w-full md:w-auto"
            onClick={closeReceivedGuidance}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  );
};
